import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleSnackBar } from './global'
import MESSAGES from '../constants/messages'
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import addressService from '../services/address.service'

export const addDeliveryAddress = createAsyncThunk(
  'address/add',
  async ({ data, callback }: { data: any; callback: any }, { dispatch }) => {
    try {
      await addressService.addAddress({ body: { data } })
      // await postAPICall(nextAPIRoutes.ADD_DELIVERY_ADDRESS, data)
      dispatch(getDeliveryAddress())
      callback()
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
    }
  },
)

export const getDeliveryAddress = createAsyncThunk(
  'address/get',
  async (_, { dispatch }) => {
    try {
      const res = await addressService.getAddress({ body: {} }) //postAPICall(nextAPIRoutes.GET_DELVERY_ADDRESS, {})
      return res?.data?.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
    }
  },
)

const deliveryAddressSlice = createSlice({
  name: 'deliveryAddress',
  initialState: {
    address: [],
  },
  reducers: {},
  extraReducers: (builder) =>
    builder.addCase(getDeliveryAddress.fulfilled, (state, { payload }) => {
      state.address = payload
    }),
})

export default deliveryAddressSlice.reducer
